// import * as util from "./util";

export default (fetch) => {
  return {
    async viewList (params) { // 授权账号管理
      const { data } = await fetch.get('/arcopen/user/account/auth/list/all', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async messageList (params) { // 授权消息管理
      const { data } = await fetch.get('/arcopen/user/account/auth/list/mine', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async handleBack (body) { // 撤销授权
      const { data } = await fetch.post('/arcopen/user/account/auth/callback', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },

    async handleRefuse (body) { // 拒绝授权
      const { data } = await fetch.post('/arcopen/user/account/auth/refuse', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },

    async handleAccept (body) { // 接受授权
      const { data } = await fetch.post('/arcopen/user/account/auth/accept', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },

    async getAvator (params) { // 授权账号管理
      const { data } = await fetch.get('/arcopen/user/account/user-info', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async fetchAppList (params) { // 查询该企业所有应用
      const { data } = await fetch.get('/arcopen/user/company-core/viewlist', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async invite (body) { // 发起授权
      const { data } = await fetch.post('/arcopen/user/account/auth/invite', body)
        return data
    },

  }
}
